import { Routes } from '@angular/router';
import { LoginGuard } from 'src/shared/guards/login.guard';

export const EntitlementsRoutes: Routes = [
  {
    path: 'entitlements',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/entitlements/entitlements.component').then((m) => m.EntitlementsComponent),
    children: [
      {
        path: 'types',
        loadComponent: () =>
          import('./pages/entitlement-types/entitlement-types.component').then((m) => m.EntitlementTypesComponent),
      },
      {
        path: 'types/create',
        loadComponent: () =>
          import('./pages/entitlement-type-form/entitlement-type-form.component').then(
            (m) => m.EntitlementTypeFormComponent
          ),
      },
      {
        path: 'types/:id',
        loadComponent: () =>
          import('./pages/entitlement-type-form/entitlement-type-form.component').then(
            (m) => m.EntitlementTypeFormComponent
          ),
      },
      {
        path: 'packages',
        loadComponent: () =>
          import('./pages/package-templates/package-templates.component').then((m) => m.PackageTemplatesComponent),
      },
      {
        path: 'packages/create',
        loadComponent: () =>
          import('./pages/package-template-form/package-template-form.component').then(
            (m) => m.PackageTemplateFormComponent
          ),
      },
      {
        path: 'packages/:id',
        loadComponent: () =>
          import('./pages/package-template-form/package-template-form.component').then(
            (m) => m.PackageTemplateFormComponent
          ),
      },
      {
        path: 'grants',
        loadComponent: () => import('./pages/grants/grants.component').then((m) => m.GrantsComponent),
      },
      {
        path: 'grants/create',
        loadComponent: () => import('./pages/grant-form/grant-form.component').then((m) => m.GrantFormComponent),
      },
      {
        path: 'grants/:id',
        loadComponent: () => import('./pages/grant-form/grant-form.component').then((m) => m.GrantFormComponent),
      },
      {
        path: 'grant-checker',
        loadComponent: () =>
          import('./pages/grant-checker/grant-checker.component').then((m) => m.GrantCheckerComponent),
      },
    ],
  },
];
